import apiClient from '@/shared/api/client';

export interface InvitationDetails {
  invitation: { id: string; email: string; contactName?: string; contactPhone?: string; expiresAt: string };
  practice: {
    id: string;
    name: string;
    website?: string;
    locations: Array<{ id: string; name: string; address?: string; city?: string; state?: string }>;
  };
}

export interface AcceptInvitationPayload {
  name: string;
  phone?: string;
}

export interface AcceptInvitationResponse {
  access_token: string;
  refresh_token: string;
  user: {
    id: string;
    email: string;
    name?: string;
    isAgency: boolean;
    practiceId: string;
    role: string;
    locationIds: string[];
  };
}

export const inviteApi = {
  verifyToken: async (token: string): Promise<InvitationDetails> => {
    const { data } = await apiClient.get<{ success: true; data: InvitationDetails }>(`/invitations/${token}`);
    return data.data;
  },

  acceptInvitation: async (token: string, payload: AcceptInvitationPayload): Promise<AcceptInvitationResponse> => {
    const { data } = await apiClient.post<{ success: true; data: AcceptInvitationResponse }>(`/invitations/${token}/accept`, payload);
    return data.data;
  },
};
